import { PostHog, PostHogProvider } from 'posthog-js/react'
import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import AppRoot from '~/app/Root'
import BizRoot from '~/biz/Root'
import XIDRAppRoot from '~/xidrApp/Root'
import XIDRBizRoot from '~/xidrBiz/Root'
import PageLoader from './components/PageLoader'
import { ConfigManager, SITE_TYPE } from './managers/ConfigManager'
import { selectIsAssetUnificationPhase2Ready } from './store/flippers/selectors'

type Props = {
  posthog: PostHog
}

// TODO(benedictkhoo): handle new AppRoot for fiat & stablecoin unification phase 2
export default function RootRenderer({ posthog }: Props) {
  const isAssetUnificationPhase2Ready = useSelector(selectIsAssetUnificationPhase2Ready)
  const isProd = ConfigManager.isProd()
  const rootComponent = useMemo(() => {
    if (!isAssetUnificationPhase2Ready) {
      return <PageLoader />
    }

    switch (ConfigManager.getSiteType()) {
      case SITE_TYPE.APP:
        return isProd ? (
          <PostHogProvider client={posthog}>
            <AppRoot />
          </PostHogProvider>
        ) : (
          <AppRoot />
        )

      case SITE_TYPE.XIDR_APP:
        return <XIDRAppRoot />

      case SITE_TYPE.BIZ:
        return isProd ? (
          <PostHogProvider client={posthog}>
            <BizRoot />
          </PostHogProvider>
        ) : (
          <BizRoot />
        )

      case SITE_TYPE.XIDR_BIZ:
        return <XIDRBizRoot />
    }

    return null
  }, [isAssetUnificationPhase2Ready])

  return rootComponent
}
